var _rect, _path, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevelopers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#fff",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DDF",
    strokeWidth: 4,
    d: "M24 18v6h-3c-1.864 0-2.796 0-3.53.305a4 4 0 0 0-2.165 2.164C15 27.204 15 28.136 15 30m9-12v6h3c1.864 0 2.796 0 3.53.305a4 4 0 0 1 2.166 2.164C33 27.204 33 28.136 33 30"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 20,
    y: 10,
    fill: "#8484FF",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 11,
    y: 30,
    fill: "#8484FF",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    x: 29,
    y: 30,
    fill: "#8484FF",
    rx: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopers);
export default __webpack_public_path__ + "static/media/developers.4c28a7fdc7d4f60e5ced10e8ae26abbd.svg";
export { ForwardRef as ReactComponent };